import { type FC } from "react";
import * as styles from "./styles.css";

// 見出しの汎用コンポーネントは、企業管理画面用と求職者画面用に分けて登録予定です。
// 今後、企業管理画面用はclientFrontend/shared配下のHeadingコンポーネントを使用してください。
// TODO: 求職者画面用のHeadingコンポーネントが作成されたら削除する

export type Size = keyof typeof styles.variant;

type Props = {
  /**
   * タイトルに表示するテキスト
   */
  children: React.ReactNode;
  /**
   * コンポーネントに適用するクラス名
   */
  className?: string;
  /**
   * コンポーネントの HTML タグ
   */
  tag: React.ElementType;
  /**
   * サイズ
   */
  size: Size;
  /**
   * 太字にするかどうか
   */
  bold?: boolean;
};

export const Heading: FC<Props> = ({ children, className, tag: Tag, size, bold = false }) => (
  <Tag
    className={`
      ${styles.variant[size]}
      ${styles.heading({
        isBold: bold,
      })}
      ${className || ""}
    `}
  >
    {children}
  </Tag>
);
